import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

import "./Certificate.css";
import CommonHeading from "../../Common_Components/Common_Heading/Common_Heading";

const certificates = [
 
   {
    image: "/assets/images/home/Certificates/GST_certificate.webp",
    title: "GST Certificate",
    subtitle: "Government of India",
  },
   {
    image: "/assets/images/home/Certificates/Certificate_img.png",
    title: "Certificate of Recognition",
    subtitle: "Ministry of Commerce & Industry",
  },
   {
    image: "/assets/images/home/Certificates/labour_department.webp",
    title: "Labour Department,Uttarpradesh",
    subtitle: "Registration Certificate of Shop or Commertial Establishment ",
  },
  // {
  //   image: "/assets/images/home/Certificates/img2.jpg",
  //   title: "Registration Certificate",
  //   subtitle: "State Govt. Approved",
  // },
  // {
  //   image: "/assets/images/home/Certificates/img3.jpg",
  //   title: "Shop & Establishment",
  //   subtitle: "",
  // },
  // {
  //   image: "/assets/images/home/Certificates/img4.webp",
  //   title: "Ministry of External Affairs",
  //   subtitle: "",
  // },
  // {
  //   image: "/assets/images/home/Certificates/img3.jpg",
  //   title: "GST Certificate",
  //   subtitle: "Goods & Services Tax",
  // },
];

export default function Certificates() {
  return (
    <section className="certificate_section container">
      <div className="certificates">
        {/* <h2>Government Certifications</h2>

        <p>
          We are officially recognized and certified by multiple government
          bodies.
        </p> */}

        <CommonHeading
          badge="our achievements"
          title="Government Certifications"
          description="We are officially recognized and certified by multiple government
          bodies."
        />

        <div className="certificate_slider">
          <Swiper
            modules={[Autoplay, Navigation]}
            spaceBetween={20}
            slidesPerView={3}
            loop={true}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
            }}
            navigation={true}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              576: {
                slidesPerView: 2,
              },
              767: {
                slidesPerView: 3,
              },
              1199: {
                slidesPerView: 3,
              },
            }}
          >
            {certificates.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="certificate">
                  <div className="certificate-image">
                    <img src={item.image} alt={item.title} />
                  </div>

                  <div className="certificate-content">
                    <h3>{item.title}</h3>
                    {item.subtitle && <span>{item.subtitle}</span>}
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}
